// 接入KAMP性能监控平台
export const apmPlugin = {
  install(app) {
    window.APM &&
      window.APM.init({
        // 应用ID，必填
        appId: '1F705Jd4',
        // 业务名称，必填
        appName: '协作空间',
        // 业务版本号
        appVersion: '1.0.0',
        // 采样率
        samplingRate: process.env.NODE_ENV !== 'production' ? 1 : 10,
        // 插件名称 @todo 端内插件场景下需要填写
        // pluginName: 'xxx-plugin',
        // 是否开启debug模式，是则在控制台输出日志
        // isDebug: process.env.NODE_ENV !== 'production',
        // 为了方便开发的时候进行调试，因此暂不开启
        isDebug: false,
        // 插件配置 - 开关策略、采样率
        pluginConfig: {
          // 性能插件配置
          performance: { switch: true },
          // 业务日志插件配置
          businessLogger: { switch: true },
          // vue框架错误捕获插件
          vue: { switch: true, app },
          // js异常错误捕获插件
          windowOnError: { switch: true },
          // web资源异常捕获插件
          windowSourceError: { switch: true },
          // promise异常捕获插件
          windowUnhandledRejection: { switch: true },
          // 资源慢加载捕获插件
          source: {
            switch: true,
            threshold: 3000,
            ignoreUrls: []
          },
          // 请求捕获插件
          request: {
            switch: true,
            threshold: 3000,
            ignoreUrls: []
          }
        }
      })
  }
}
